<template>
  <section class="container section pt-0">
    <shortcut-profile-datatable />
  </section>
</template>

<script>
import ShortcutProfileDatatable from "./shortcut_profile_datatable/Index.vue";

export default {
  name: "ShortcutIndex",
  components: { ShortcutProfileDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
